import { OnInit } from '@angular/core';
import * as _ from 'lodash';
var TabApprovalsEquipmentsAttachmentsComponent = /** @class */ (function () {
    function TabApprovalsEquipmentsAttachmentsComponent(approval) {
        this.approval = approval;
    }
    TabApprovalsEquipmentsAttachmentsComponent.prototype.ngOnInit = function () {
        this.approval.equipment.attachments = _.filter(this.approval.equipment.attachments, function (attachment) { return attachment.archived === false; });
    };
    return TabApprovalsEquipmentsAttachmentsComponent;
}());
export { TabApprovalsEquipmentsAttachmentsComponent };
